import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createCalendarHolidays(
    request: Boundaries["createCalendarHolidays"]["request"],
  ): void;
}

function useCreateCalendarHolidays(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isCreateCalendarHolidaysRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isCreateCalendarHolidaysRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isCreateCalendarHolidaysRequestFailure,
    ),
    createCalendarHolidays: core.createCalendarHolidays,
  };
}

export { useCreateCalendarHolidays };
